import React from "react"
import { close } from "@app/scripts/hooks/icons"
import { useSearchspringFilters } from "@app/scripts/hooks/use-searchspring-filters"

export function FilterSortDrawerActiveItems() {
  const { activeFilters, handleRemoveFilter, handleClearFilters } =
    useSearchspringFilters()

  // Sanitize activeFilters to make sure they show front end friendly
  const activeFiltersArray = Array.from(activeFilters ?? []).map((item) => {
    const [field, rawValue = ""] = item.split(":")
    let label = rawValue.toLowerCase()

    if (field === "ss_price") {
      const [low, high] = rawValue.split("<>")
      if (low && high) {
        label = `$${low} - $${high}`
      }
    }

    return { key: item, label }
  })

  if (activeFiltersArray.length === 0) return null

  return (
    <div className="filter-sort-drawer-active-items--list">
      {activeFiltersArray.map(({ key, label }) => (
        <div
          onClick={() => handleRemoveFilter(key)}
          key={key}
          className="filter-sort-drawer--active-item"
        >
          {label} <span>{close}</span>
        </div>
      ))}
      <p
        className="filter-sort-active-items--close underline"
        onClick={handleClearFilters}
      >
        Clear All
      </p>
    </div>
  )
}
